"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 228: Action 52
 * ------------------------------------------------------------------ */
// Action 52. Mapper 90 is a different board entirely and lives in jycompany.js.

function register(Mappers) {
  function Action52(nes) {
    this.nes = nes;
  }

  Action52.prototype = new Mappers[0]();

  Action52.prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.prgBank = 0;
    this.chrBank = 0;
    // The board has no register for the $C000 window, so it is fixed at the last
    // bank. Named here so the power-on mapping and a restored one agree.
    this.prgBankFixed = 0;
  };

  Action52.prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // Bits 0-2 select a 16 KB PRG bank, bits 3-4 an 8 KB CHR bank. Both halves
    // come out of one register, so the CHR number is kept as its own field: it is
    // state the board holds, and a save that dropped it would restore the PRG bank
    // with the wrong pattern table behind it.
    this.prgBank = value & 0x07;
    this.chrBank = (value >> 3) & 0x03;
    this.updateBanks();
  };

  Action52.prototype.updateBanks = function () {
    this.loadRomBank(this.prgBank, 0x8000);
    this.loadRomBank(this.prgBankFixed, 0xc000);
    this.load8kVromBank(this.chrBank * 2, 0x0000);
  };

  Action52.prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Action 52: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.prgBankFixed = this.nes.rom.romCount - 1;
    this.updateBanks();
    this.resetIrqHandler();
  };

  Action52.prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.prgBank = this.prgBank;
    s.chrBank = this.chrBank;
    s.prgBankFixed = this.prgBankFixed;
    return s;
  };

  Action52.prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.prgBank = s.prgBank;
    this.chrBank = s.chrBank;
    this.prgBankFixed = s.prgBankFixed;
    this.updateBanks();
  };

  Mappers[228] = Action52;
}

module.exports = { register: register };
